import './new-reward-event.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormRewardEvent from "../form-reward-event/form-reward-event";
import { useNewRewardEvent } from './new-reward-event.hook';

export function NewRewardEvent() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewRewardEvent();

  return (
    <div id="NewRewardEvent" className="reward-event">
      <HeaderContent
        title={<h1>New Reward Event</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormRewardEvent hasLevel={false} />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewRewardEvent;